import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import {
  Body1,
  NoticeArea,
  NoticeText,
  RightArea,
  TopBar,
} from "pages/home/components/HeaderSection/styled";
import { getAdminNotice } from "shared/api/AdminNoticeApi";
import { useMyProfile } from "shared/api/useMyProfile";
import { alertDialog } from "shared/ui/feedback";

/**
 * 관리자 공통 헤더 섹션.
 * 모든 페이지 상단에 깔리며, 좌측에 관리자 페이지 공지를, 우측에 사용자명/로그아웃을 둔다.
 * (공지 관리는 설정 페이지에서 한다.)
 */
export const HeaderSection = () => {
  const token = localStorage.getItem("admintoken");
  const navigate = useNavigate();
  // 프로필은 앱 전역 공유 캐시(useMyProfile)에서 읽는다(사이드바·라우트 가드와 동일 소스).
  const { data: userInfo } = useMyProfile();

  // 공지는 React Query 캐시로 관리한다. 설정에서 수정 시 같은 캐시 키를 갱신하면
  // 전체 새로고침 없이 이 헤더만 리렌더된다(queryKey: ["adminNotice"]).
  const { data: noticeData } = useQuery({
    queryKey: ["adminNotice"],
    queryFn: getAdminNotice,
    enabled: Boolean(token),
  });
  const notice = noticeData?.content || "";

  const handleLogout = () => {
    localStorage.removeItem("admintoken");
    navigate("/login");
    window.location.reload();
    alertDialog("로그아웃 되었습니다!");
  };

  const handleLoginClick = () => {
    navigate("/login");
    window.location.reload();
  };

  return (
    <TopBar>
      <NoticeArea>
        {notice ? (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 40 40"
              fill="none"
              style={{ marginRight: "12px", flexShrink: 0 }}
            >
              <path
                d="M22.6667 12.9405H10.2222C8.26669 12.9405 6.66669 14.3523 6.66669 16.0778V22.3523C6.66669 24.0778 8.26669 25.4895 10.2222 25.4895H12V30.1954C12 31.9209 13.6 33.3327 15.5556 33.3327H19.1111V25.4895H22.6667L29.7778 31.7641H33.3334V6.66602H29.7778L22.6667 12.9405Z"
                fill="#0079E0"
              />
            </svg>
            <NoticeText title={notice}>{notice}</NoticeText>
          </>
        ) : null}
      </NoticeArea>
      <RightArea>
        <Body1 $color="#0079E0">
          {userInfo?.name ? `${userInfo.name}님` : ""}
        </Body1>
        {token ? (
          <Body1 onClick={handleLogout}>로그아웃</Body1>
        ) : (
          <Body1 onClick={handleLoginClick}>로그인</Body1>
        )}
      </RightArea>
    </TopBar>
  );
};
